import { connect } from 'react-redux';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import Assets from 'presentation/components/SecurePaymentForm/shared/assets';
import { getCustomText } from 'app/modules';
import overrideStyle from 'lib/overrideStyle';

export function NumberField(props) {
  const errorOccurred = !props.formState.isValid && !props.formState.isEmpty;

  useEffect(() => {
    props.form.field('#cc-number', {
      css: props.cssBase,
      errorColor: '#D8000C',
      name: 'cardNumber',
      placeholder: props.placeholder,
      successColor: '#000000',
      type: 'card-number',
      validations: ['required', 'validCardNumber'],
      showCardIcon: {
        paddingBottom: '4px',
        paddingRight: '8px',
      },
    });
  }, []);

  return (
    <NumberCollectionField isFocused={props.formState.isFocused} shouldShowError={errorOccurred}>
      <Assets.CollectionFieldLabel shouldShowError={errorOccurred}>
        {errorOccurred ? props.error : props.label}
      </Assets.CollectionFieldLabel>
      <div id="cc-number" />
    </NumberCollectionField>
  );
}

const NumberCollectionField = overrideStyle(Assets.CollectionField)`
  margin-top: 32px;
`;

NumberField.propTypes = {
  cssBase: PropTypes.object.isRequired,
  error: PropTypes.string.isRequired,
  form: PropTypes.object.isRequired,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string.isRequired,
  formState: PropTypes.object.isRequired,
};

export const mapStateToProps = state => {
  let formText = getCustomText(state).payment.form;

  return {
    error: formText.number.error,
    label: formText.number.label,
    placeholder: formText.number.placeholder,
  };
};

export default connect(mapStateToProps)(NumberField);
